var map = {
	"./block-1.jpg": "b722",
	"./block-2.jpg": "5699",
	"./block-3.jpg": "108c",
	"./chess.jpg": "d01e",
	"./giraffe.jpg": "9070",
	"./graphics/VK.svg": "26a3",
	"./graphics/arrow.svg": "ac10",
	"./graphics/bubble.png": "1c84",
	"./graphics/chess.svg": "3d19",
	"./graphics/close-btn.svg": "22c9",
	"./graphics/facebook.svg": "9876",
	"./graphics/favicon.png": "970c",
	"./graphics/giraffe.svg": "f3f7",
	"./graphics/guitar.svg": "7b93",
	"./graphics/link-icon.svg": "0510",
	"./graphics/logo.svg": "e91d",
	"./graphics/signature.png": "c6fc",
	"./graphics/telegram.svg": "a557",
	"./graphics/video-game.svg": "e8d4",
	"./graphics/volleyball.svg": "4d0c",
	"./graphics/waves.png": "bbbb",
	"./graphics/whatsapp.svg": "b8b5",
	"./guitar.jpg": "f464",
	"./main-1.png": "f129",
	"./main-2.png": "6479",
	"./main-bio-1-1.jpg": "6a1b",
	"./valleyball.jpg": "bf5f",
	"./video-games.jpg": "87c6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";